import styled from 'styled-components';
import Colors from './Colors';
import { media, viewportHeight, CONTAINER_MAX_WIDTHS, TOUCH_TARGET } from '../styles/breakpoints';

const AppContainer = styled.div`
  margin: auto;
  /* Fix for mobile browsers - use dvh with vh fallback */
  ${viewportHeight(100)}
  background: white;

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 15% 60% 10% 15%;
  grid-template-areas: "Header" "Section" "Navigation" "Footer";

  justify-items: center;

  /* Mobile-first: full width */
  max-width: 100%;
  width: 100%;

  /* Tablet: constrain width */
  ${media.tablet} {
    max-width: ${CONTAINER_MAX_WIDTHS.tablet};
  }

  /* Laptop and above */
  ${media.laptop} {
    max-width: ${CONTAINER_MAX_WIDTHS.laptop};
  }

  /* Landscape mobile devices */
  ${media.landscape} {
    ${media.maxTablet} {
      max-width: 60vh;
      max-width: 60dvh;
    }
  }
`;

const HeaderContainer = styled.div`
  grid-area: Header;
  justify-self: stretch;
`;

const SectionContainer = styled.div`
  grid-area: Section;
  justify-items: center;


  display: flex;
  flex-direction: column;

  // grid-template-columns: 1fr;
  // grid-template-rows: 15% 70% 15%;
  // grid-template-rows: 15% 50% 35%;

`;

const NavigationContainer = styled.div`
  grid-area: Navigation;
`;

const FooterContainer = styled.div`
  grid-area: Footer;
  justify-self: stretch;
`;

const BtnContainer = styled.div`
  margin-top: 1.5vh;
  margin-top: 1.5dvh;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1vh;
  margin-bottom: 1dvh;
  justify-content: center;
  display: flex;
  position: relative;
  z-index: 9999;

  /* Mobile: wider buttons for easier tapping */
  width: 80%;
  max-width: 320px;
  min-height: ${TOUCH_TARGET.comfortable};

  /* Tablet and up: constrained width */
  ${media.tablet} {
    width: 25vh;
    width: 25dvh;
    max-width: 280px;
  }

  /* Ensure buttons are tappable */
  button {
    min-height: ${TOUCH_TARGET.comfortable};
    width: 100%;
  }
`;

const BtnContainer2 = styled.div`
  margin-top: 1.5vh;
  margin-top: 1.5dvh;
  height: 13vh;
  height: 13dvh;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1vh;
  margin-bottom: 1dvh;
  justify-content: center;
  text-align: center;
  display: flex;
  position: relative;
  z-index: 9999;

  /* Mobile: wider container */
  width: 90%;

  /* Tablet: constrain width */
  ${media.tablet} {
    width: 45vh;
    width: 45dvh;
  }
`;

const CusButton = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight:600;
  max-width: 100%;
  max-height: 100%;
  width: 88%;
  background-color: ${Colors.VIOLET_PURP};
  border-radius: 20px;
  color: white;
  border: none;
  position: relative;
  z-index: 11;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;

  /* Responsive font size */
  font-size: 14px;
  padding: 16px 20px;
  min-height: ${TOUCH_TARGET.comfortable};

  ${media.mobile} {
    font-size: 15px;
    padding: 18px 20px;
  }

  ${media.tablet} {
    font-size: 2vh;
    font-size: 2dvh;
    padding: 20px 20px;
  }
`;

const TextContainer = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
  min-height: 8vh;
  min-height: 8dvh;
  padding: 0 1rem;

  /* More padding on larger screens */
  ${media.tablet} {
    padding: 0 2rem;
  }
`;

const Box = styled.div`
  background: #fff;
  margin: auto;
  width: 90%;
  height: 25vh;
  height: 25dvh;
  box-shadow: 0 9px 17px 12px rgba(195,192,192,.5);
  padding: 3px 16px 1px 16px;
  white-space: pre-wrap;

  /* Tablet and up: constrain width */
  ${media.tablet} {
    max-width: 50vh;
    max-width: 50dvh;
    padding: 3px 20px 1px 20px;
  }
`;

const Box2 = styled.div`
  background: #fff;
  margin: auto;
  width: 90%;
  max-height: 100%;
  box-shadow: 0 9px 17px 12px rgba(195,192,192,.5);
  padding: 24px 16px 0px 16px;
  white-space: pre-wrap;

  /* Tablet and up */
  ${media.tablet} {
    max-width: 50vh;
    max-width: 50dvh;
    padding: 40px 20px 0px 20px;
  }
`;

const AppHeader = styled.div`
  padding-top: 2vh;
  padding-top: 2dvh;
  width: 100%;
  height: 100%;
  display: flex;
  box-sizing: border-box;
  justify-content: center;
`;

const CustomTextParagraph = styled.div`
  /* Responsive font size */
  font-size: 14px;
  margin-top: 1.5vh;
  margin-top: 1.5dvh;
  justify-content: center;
  display: flex;
  text-align: center;
  min-height: 4vh;
  min-height: 4dvh;

  ${media.tablet} {
    font-size: 1.8vh;
    font-size: 1.8dvh;
  }
`;

const InfoTextParagraph = styled.div`
  /* Responsive font size */
  font-size: 12px;
  padding-top: 1.5vh;
  padding-top: 1.5dvh;

  ${media.tablet} {
    font-size: 1.4vh;
    font-size: 1.4dvh;
  }
`;

const CustomTextContainer = styled.div`
  /* Responsive margin */
  margin: 3vh 1rem 3vh;
  margin: 3dvh 1rem 3dvh;

  ${media.tablet} {
    margin: 3vh 8vh 3vh;
    margin: 3dvh 8dvh 3dvh;
  }
`;

const LinkButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  display: inline;
  margin: 0;
  margin-left: 0.5rem;
  padding: 8px;
  /* Minimum touch target */
  min-height: ${TOUCH_TARGET.minimum};

  /* Responsive font size */
  font-size: 12px;

  ${media.tablet} {
    font-size: 1.4vh;
    font-size: 1.4dvh;
    margin-left: 1vh;
    margin-left: 1dvh;
  }

  /* Accessibility: larger tap area on touch devices */
  ${media.touch} {
    padding: 12px;
  }
`;

const Info = styled.div`
  /* Responsive font size */
  font-size: 16px;
  padding-top: 11px;

  ${media.tablet} {
    font-size: 2vh;
    font-size: 2dvh;
  }
`;


export {
  AppContainer,
  HeaderContainer,
  SectionContainer,
  NavigationContainer,
  FooterContainer,
  BtnContainer,
  BtnContainer2,
  CusButton,
  TextContainer,
  Box,
  AppHeader,
  CustomTextParagraph,
  InfoTextParagraph,
  CustomTextContainer,
  LinkButton,
  Info,
  Box2,
};
